import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { useMemo, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';
import { useAccessibleRef } from '@jutro/platform';
import { dropdownMenuLinkPropTypes, IntlMessageShape, IntlToShape } from '@jutro/prop-types';
import { useSafeTranslatedUrls, TranslatorContext } from '@jutro/locale';
import styles from "./DropdownMenu.module.css";
export const DropdownMenuLink = props => {
  const id = props.id,
    className = props.className,
    activeClassName = props.activeClassName,
    disabled = props.disabled,
    children = props.children,
    onClickProp = props.onClick,
    visible = props.visible,
    focused = props.focused,
    onMenuItemClick = props.onMenuItemClick,
    dangerouslySetInnerHTML = props.dangerouslySetInnerHTML,
    to = props.to,
    href = props.href,
    target = props.target,
    relProp = props.rel,
    other = _objectWithoutProperties(props, ["id", "className", "activeClassName", "disabled", "children", "onClick", "visible", "focused", "onMenuItemClick", "dangerouslySetInnerHTML", "to", "href", "target", "rel"]);
  const translator = useContext(TranslatorContext);
  const urlTranslatorAndSanitizer = useSafeTranslatedUrls();
  const onClick = useMemo(() => disabled ? evt => evt.preventDefault() : evt => {
    onMenuItemClick === null || onMenuItemClick === void 0 ? void 0 : onMenuItemClick();
    onClickProp === null || onClickProp === void 0 ? void 0 : onClickProp(evt);
  }, [disabled, onMenuItemClick, onClickProp]);
  const linkRef = useAccessibleRef(focused);
  if (visible === false) {
    return null;
  }
  const translatedChildren = translator(children);
  const classes = cx(styles.link, {
    [styles.disabled]: disabled
  }, className);
  const safeTo = to && urlTranslatorAndSanitizer(to);
  if (safeTo) {
    return React.createElement(NavLink, _extends({
      id: id,
      className: classes,
      activeClassName: activeClassName,
      onClick: onClick,
      disabled: disabled,
      "aria-disabled": disabled,
      innerRef: linkRef,
      tabIndex: disabled ? -1 : 0,
      to: safeTo
    }, other), translatedChildren);
  }
  const safeHref = href ? urlTranslatorAndSanitizer(href) : safeTo;
  const rel = target === '_blank' ? 'noreferrer' : relProp;
  return React.createElement("a", _extends({
    id: id,
    className: classes,
    onClick: onClick,
    href: safeHref,
    "aria-disabled": disabled,
    ref: linkRef,
    target: target,
    rel: rel,
    tabIndex: disabled ? -1 : 0
  }, other), translatedChildren);
};
DropdownMenuLink.propTypes = dropdownMenuLinkPropTypes;
DropdownMenuLink.__docgenInfo = {
  componentName: "DropdownMenuLink",
  packageName: "@jutro/router",
  description: "DropdownMenuLink",
  displayName: "DropdownMenuLink",
  methods: [],
  actualName: "DropdownMenuLink",
  metadataType: "action",
  composes: ["@jutro/prop-types"]
};